import { render, staticRenderFns } from "./_Banners.vue?vue&type=template&id=fd266a54&scoped=true&"
import script from "./_Banners.vue?vue&type=script&lang=js&"
export * from "./_Banners.vue?vue&type=script&lang=js&"
import style0 from "./_Banners.vue?vue&type=style&index=0&id=fd266a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd266a54",
  null
  
)

export default component.exports